export default "__VITE_ASSET__BAOqM87E__"